import React from 'react';
import { TFunction } from 'i18next';
import { ViewAndActionButtons } from './ViewAndActionButtons';
import {
  BlockInteractionsState,
  ButtonsType,
  GetButtonModifier,
  GetHref,
  GetTitleText,
  ToggleActiveView,
  ViewsType,
} from '../BlockInteractionsTypes';
import { ContentWrapperContext } from '../../../blocks/ContentWrapper/ContentWrapperContext';

type BlockInteractionsButtons = {
  state: BlockInteractionsState;
  buttons?: ButtonsType;
  views: ViewsType;
  id: string;
  uuid: string;
  elementType: string;
  contentWrapperProps?: ContentWrapperContext | null;
  getTitleText: GetTitleText;
  getButtonModifier: GetButtonModifier;
  getHref: GetHref;
  isInLayoutGroup?: boolean;
  toggleActiveView: ToggleActiveView;
  t: TFunction;
};

export function BlockInteractionsButtons({
  state,
  buttons,
  views,
  id,
  uuid,
  elementType,
  contentWrapperProps,
  getTitleText,
  getButtonModifier,
  getHref,
  isInLayoutGroup,
  toggleActiveView,
  t,
}: BlockInteractionsButtons) {
  return (
    <div className="block-interactions__buttons">
      <ViewAndActionButtons
        state={state}
        buttons={buttons}
        views={views}
        id={id}
        uuid={uuid}
        elementType={elementType}
        contentWrapperProps={contentWrapperProps}
        getTitleText={getTitleText}
        getButtonModifier={getButtonModifier}
        getHref={getHref}
        isInLayoutGroup={isInLayoutGroup}
        toggleActiveView={toggleActiveView}
        t={t}
      />
    </div>
  );
}
